import { IconProps } from "@assets";

const PreviousElement = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg
            width={props.size ?? "60"}
            height={props.size ?? "60"}
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle r="29" transform="matrix(1 -2.06807e-08 2.70888e-08 -1 30 30)" stroke="#D7E3F5" strokeWidth="2" />
            <path
                d="M33 22L25 29.9998L33 38"
                stroke="#D7E3F5"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PreviousElement;
